<template>
  <div class="home">
    <div class="home_banner">
      <comswiper :resbanner="banner"></comswiper>
    </div>
    <div class="main_product mainWidth">
      <div class="main_title_box ">
        <div class="main_title">
          {{$t('main.mainProduct.title')}}
          </div>
        <div class="main_subtitle">
          {{$t('main.mainProduct.subtitle')}}
          </div>
      </div>
      <mu-row gutter class="intro_box">
        <mu-col class="intro_item" v-for="item in $t('main.mainProduct.intro')" :key="item.title" width="20" tablet="20" desktop="20">
          <router-link tag="div"  :to="item.linkUrl">
            <img :src="item.imgUrl" alt="" class="intro_img">
            <div class="intro_title">
              {{item.title}}
                </div>
          </router-link>
        </mu-col>
      </mu-row>
    </div>
    <div class="main_service">
      <div class="mainWidth">
        <div class="main_title_box ">
          <div class="main_title">
            {{$t('main.mainService.title')}}
            </div>
          <div class="main_subtitle">
            {{$t('main.mainService.subtitle')}}
            </div>
        </div>
        <mu-row gutter class="intro_box">
          <mu-col class="intro_item" v-for="item in $t('main.mainService.intro')" :key="item.linkUrl" width="25" tablet="25" desktop="25">
            <router-link tag="div"  :to="item.linkUrl">
              <img :src="item.imgUrl" alt="" class="intro_img">
              <div class="intro_title">
                {{item.title}}
                  </div>
            </router-link>
          </mu-col>
        </mu-row>
      </div>

    </div>
    <div class="main_news">
      <div class="mainWidth">
        <div class="main_title_box">
          <div class="main_title">
            {{$t('main.mainNews.title')}}
            </div>
          <div class="main_subtitle">
            {{$t('main.mainNews.subtitle')}}
            </div>
        </div>
        <mu-row gutter class="news_box">

          <mu-col class="news_videos"  v-for="videos in videos" :key="videos.videoimgurl" width="35" tablet="35" desktop="35">
            <div class="videos_title_box">
              <div class="videos_column_title">
                {{$t('common.videos')}}
              </div>
              <router-link to="/videolist">
                <div class="videos_more">
                  {{$t('common.more')}}
                </div>
              </router-link>
            </div>
            <div class="videos_box">
              <div class="videos_cover_box">
                <img :src="videos.videoimgurl" />
                <div class="mask">
                  <div class="videos_play middle" @click="getVideo(videos.videoid)">

                  </div>
                </div>
                <div class="videos_duration">

                  <div class="videos_icon_clock">
                  </div>
                  <div class="videos_creattime">
                    {{videos.createtime}}
                  </div>
                </div>
              </div>
              <div class="videos_title"  @click="getVideo(videos.videoid)">
                {{videos.title}}
              </div>
              <!--<div class="videos_intro">-->
                <!--{{videos.describes}}-->
              <!--</div>-->
              <div class="videos_other">
                <div class="videos_time">
                  {{videos.createtime}}
                </div>
                <div class="videos_playnumber">
                  <span class="icon_view"></span>
                  <span class="number">
                    {{videos.playnumber}}
                  </span>

                </div>
              </div>
            </div>
            <!--<comvideoplayer></comvideoplayer>-->
          </mu-col>
          <mu-col class="news_list" width="65" tablet="65" desktop="65">
            <div class="news_title_box">
              <div class="news_column_title">
                {{$t('common.news')}}
                </div>
              <router-link to="/articlelist">
                <div class="news_more">
                  {{$t('common.more')}}
                </div>
              </router-link>

            </div>
            <mu-row   v-for="news in news" :key="news.title" class="news_box">
              <mu-col class="" width="100" tablet="100" desktop="100">

                <div class="">
                  <div class="news_title oneLine" @click="getArticle(news.newsid)">
                    {{news.title}}
                  </div>
                  <div class="news_abstract oneLine">
                    {{news.contents}}
                  </div>
                  <div class="news_other">
                    <span class="icon_creattime"></span>
                    <div class="news_time">
                      {{news.createtime}}
                    </div>
                  </div>
                </div>
              </mu-col>
              <!--<mu-col class="news_link_box"  width="30" tablet="30" desktop="30">-->
                <!--<div class="news_link middle" @click="getArticle(news.newsid)">-->
                  <!--{{$t('common.showMore')}}-->
                <!--</div>-->
              <!--</mu-col>-->
            </mu-row>
          </mu-col>
        </mu-row>
      </div>

    </div>
  </div>
</template>

<script>
  import comswiper from "../components/comswiper"
  export default {
    name: 'home',
    metaInfo: {
      title: '速得尔科技（北京）有限公司_电子靶_激光射击', // set a title
      meta: [{                 // set meta
        name: 'keyWords',
        content: '电子靶，激光靶，电子报靶系统，激光射击系统，智能靶场系统，枪弹柜，超级射手，赛事直播，赛事服务，速得尔电子靶'
      }, {                 // set meta
        name: 'description',
        content: '速得尔是中国射击装备领导品牌，荣获国家高新技术企业，第十三届全运会优秀赛事承办单位等称号，电子靶及相关产品远销全国31个省市自治区，市场占有率超过70%。速得尔以创新技术服务中国射击事业！'
      }]
    },
    data () {
      return {
        videos:[],
        news:[],
        playVideo:true,
        banner:this.$t('main.mainBanner.banner')
      }
    },
    created(){
      this.reqVideo();
      this.reqNews();
    },
    components:{
      comswiper
    },
    methods:{
      routeTo(path,url,type){
        if(path===""){
          window.open(url);
//        window.location.href=url;
        }else{

        }
      },
      reqVideo(){ //请求视频
        this.$http({
          root:'http://www.supershooter.cn:8099/webapi/video',
          method:'post',
          params:{
            pageIndex:1,
            pageSize:1,
          }
        }).then((res)=>{
          this.sw=true;
          if(res.body.code==200){
            this.videos=res.body.data;
          }else{
            this.showErr(res);
          }
        },(res)=>{
          this.showErr(res);
        });
      },
      reqNews(){ //请求新闻
        this.$http({
          root:'http://www.supershooter.cn:8099/webapi/news',
          method:'post',
          params:{
            pageIndex:1,
            pageSize:3,
          }
        }).then((res)=>{
          this.sw=true;
          if(res.body.code==200){
            this.news=res.body.data;
          }else{
            this.showErr(res);
          }
        },(res)=>{
          this.showErr(res);
        });
      },
      getArticle(id){ //跳转到列表详情
        this.$router.push({name:"article",params:{id:id}});
      },
      getVideo(id){ //跳转到列表详情
        this.$router.push({name:"video",params:{id:id}});
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .home{
    animation:all 300ms;
  }
  .home_banner{
    margin-top:4px;
    height:380px;
    width:inherit;
    .linshi{
      text-align:center;
      height:300px;
      font-size:42px;
    }
  }
  .main_product,.main_service,.main_honor,.main_news{
    width:inherit;
    height:507px;
    overflow:hidden;
    .main_title_box{
      height:80px;
      text-align:center;
      margin:45px 0px;
      .main_title{
        height:40px;
        line-height:40px;
        font-size: 28px;
        color: #333333;
        letter-spacing: 0;
      }
      .main_subtitle{
        ont-size: 18px;
        color: #9A9A9A;
        letter-spacing: 0;
        line-height: 40px;
      }
    }
    .intro_box{
      height:260px;
      padding:10px;
      .intro_item{
        height:inherit;
        text-align:center;
        &:hover{
          box-shadow: 0 10px 10px 0 rgba(0,0,0,0.06)!important;
        }
        .intro_img{
          width:200px;
          height:200px;
          border-radius:10px;
          margin:0 auto;
          cursor:pointer;
        }
        .intro_title{
          font-size: 20px;
          color: #333333;
          letter-spacing: 0;
          height:28px;
          line-height:28px;
          margin:30px auto;
          cursor:pointer;
        }
      }
    }

  }
  .main_service{ //定义产品与服务单独样式
    background:url("../assets/images/bg-server.png") no-repeat center center;
    background-size:auto 100%;
    height:480px!important;
    div{
      color:#fff!important;
    }
    .intro_img{
      width:120px!important;
      height:120px!important;;
    }
  }
  .main_honor{ //定义荣誉单独样式
    height:532px!important;
    .intro_img{
      width:260px!important;
      height:180px!important;;
    }
    .intro_title{
      font-size: 14px!important;
      color: #3B3B3B!important;
      letter-spacing: 0;
    }

  }
  .main_news{
    min-height:632px!important;
    overflow:hidden;
    background: #F6F9FA;
    .news_box{
      .news_videos{
        /*margin-right:21px;*/
      }
      .videos_title_box{
        width:100%;
        height:55px;
        border-top:4px solid #FF7F7F;
        .videos_column_title{
          font-family: PingFangSC-Medium;
          height:51px;
          font-size: 18px;
          color: #FF7F7F;
          letter-spacing: 0;
          line-height: 40px;
          float:left;
          font-weight:600;
        }
        .videos_more{
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #C3C3C3;
          letter-spacing: 0;
          line-height: 40px;
          float:right;
          cursor:pointer;
          font-weight:600;
        }
        .videos_more:hover{
          color: #FF7F7F;
        }
      }
      .videos_box{
        width:100%;
        height:auto;
        overflow:hidden;
        position:relative;
        background: #FFFFFF;
        transition:all 500ms;
        border-radius: 2px;
        &:hover{
          box-shadow: 0 8px 10px 0 rgba(0,0,0,0.09);
        }
        .videos_cover_box{
          position:relative;
          width:inherit;
          height:258px;
          overflow:hidden;
          >img{
            width:100%;
            height:100%;
          }
          .mask{
            position:absolute;
            top:0;
            left:0;
            width:inherit;
            height:inherit;
            background-color:rgba(0,0,0,0.3);

            .videos_play{
              width:62px;
              height:62px;
              background:url("../assets/images/play.png") no-repeat center center;
              background-size:100% 100%;
              cursor:pointer;
            }
          }
        }
        .videos_duration{
          position:absolute;
          background:rgba(0,0,0,0.3);
          border-radius: 100px;
          right:10px;
          bottom:10px;
          font-size: 12px;
          color: #FFFFFF;
          letter-spacing: 0;
          padding:9px 20px;
          height:36px;
          .videos_icon_clock{
            width:18px;
            height:18px;
            bakcground:blue;
            float:left;
            background:url("../assets/images/clock.png") no-repeat center center;
            background-size:100% 100%;
            margin-right:5px;
          }
          .videos_creattime{
            float:left;
            font-size: 12px;
            color: #FFFFFF;
            letter-spacing: 0;
          }
        }
        .videos_title{
          font-size: 18px;
          color: #21A1E5;
          letter-spacing: 0;
          line-height: 16px;
          font-weight:600;
          padding:20px 16px;
          line-height:24px;
          min-height:24px;
          &:hover{
            cursor:pointer;
          }
        }
        .videos_intro{
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #9398A1;
          letter-spacing: 0;
          line-height: 20px;
          padding:0px 16px;
          min-height:40px;
        }
        .videos_other{
          height:15px;
          line-height:15px;
          font-size: 12px;
          color: #B5BAC4;
          letter-spacing: 0;
          padding:0px 16px;
          margin-bottom:15px;
          .videos_time{
            float:left;
          }
          .videos_playnumber{
            float:right;
            display:block;
            height:15px;
            line-height:15px;
            .icon_view{
              display:inline-block;
              width:20px;
              height:15px;
              background: url("../assets/images/eye.png") no-repeat center center;
              background-size:100% 100%;
              float:left;
            }
            .number{
              display:block;
              height:15px;
              line-height:16px;
              width:50px;
              padding-left:10px;
              float:left;
            }

          }
        }
      }
      .news_list{
        height:auto;
        .news_title_box{
          width:100%;
          height:55px;
          border-top:4px solid #21A1E5;
          .news_column_title{
            font-family: PingFangSC-Medium;
            height:51px;
            font-size: 18px;
            color: #21A1E5;
            letter-spacing: 0;
            line-height: 40px;
            float:left;
            font-weight:600;
          }
          .news_more{
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #C3C3C3;
            letter-spacing: 0;
            line-height: 40px;
            float:right;
            cursor:pointer;
            font-weight:600;
          }
          .news_more:hover{
            color: #21A1E5;
          }
        }
        .news_box{
          height:123px;
          margin-bottom:11px;
          background:#ffffff;
          padding:0px 37px;
          transition:all 500ms;
          &:hover{
            box-shadow: 0 8px 10px 0 rgba(0,0,0,0.09);

            .news_title{
              color: #21A1E5;
              &:hover{
                cursor:pointer;
              }
            }
          }
          .news_title{
            font-size: 18px;

            color: #3B3B3B;
            letter-spacing: 0;
            line-height: 16px;
            font-weight:600;
            line-height:24px;
            min-height:24px;
            padding:16px 0px;
          }
          .news_abstract{
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #9398A1;
            letter-spacing: 0;
            line-height: 20px;
            min-height:30px;
          }
          .news_other{
            display:block;
            height:15px;
            line-height:15px;
            .icon_creattime{
              display:inline-block;
              width:15px;
              height:15px;
              background: url("../assets/images/clock-2.png") no-repeat center center;
              background-size:100% 100%;
              float:left;
            }
            .news_time{
              display:block;
              color: #9398A1;
              height:15px;
              line-height:16px;
              padding-left:10px;
              float:left;
            }


          }
          .news_link_box{
            position:relative;
            height:inherit;
            .news_link{
              display:block;
              border: 1px solid #2095D4;
              border-radius: 2px;
              width:120px;
              height:40px;
              line-height:40px;
              text-align:center;
              font-size: 14px;
              color: #2095D4;
              letter-spacing: 0;
              transition:all 500ms;
              cursor:pointer;
              &:hover{
                background: #21A1E5;
                color:#fff;
              }
            }
          }
        }
      }
    }
  }
  .play_video_box{
    position: fixed;
    left:0;
    right:0;
    top:0;
    bottom:0;
    background:red;
    z-index:100;
  }
</style>




// WEBPACK FOOTER //
// src/page/home.vue